<template>
	<section class="section-table">
		<pagination
			class="pagination-top"
			:total="tasks.total"
			:page.sync="tasks.current_page"
			:limit.sync="tasks.per_page"
			@pagination="getTasks(false)"
			@sizeChange="getTasks(true)"
			:separate-change="true"
			:page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
			:slotStacked="true"
			slotPosition="before"
		>
			<section class="w-100">
				<div class="w-100 d-flex justify-content-between">
					<el-button size="small" type="success" @click="openTaskModal()">Create Task</el-button>
					<el-button style="margin-left: 10px" size="small" type="primary" @click="getTasks(true)">Reload Tasks</el-button>
					<el-select v-model="filter" style="margin-left: 10px; width: 250px" size="small">
						<el-option v-for="item in options.filter" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>

					<el-select
						v-if="showFilterByBroker"
						style="margin-left: 10px; width: 250px"
						size="small"
						v-model="filterBroker"
						clearable
						filterable
						placeholder="Filter by Broker"
                        :loading="_.isEmpty(brokerList)"
					>
						<el-option-group v-for="group in brokerList" :key="group.label" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-option-group>
					</el-select>

					<el-input clearable style="margin-left: 10px" size="small" v-model="search" placeholder="Search Tasks"></el-input>

                    <div v-if="_.size(multipleSelection) > 0 && _.get(brokerList, '0.options', false)" class="d-flex flex-row assign-user" style="margin-left: 10px;">
                        <el-select clearable filterable size="small" v-model="assignUserId" placeholder="Select Broker">
                            <el-option
                                v-for="broker in brokerList[0].options"
                                :key="broker.value"
                                :label="broker.label"
                                :value="broker.value">
                            </el-option>
                        </el-select>
                        <el-button @click="assignTasks" :disabled="!assignUserId" type="primary" size="small">Assign Tasks</el-button>
                    </div>

                    <div v-if="_.size(multipleSelection) > 0" class="d-flex flex-row" >
                        <el-button @click="multiSelectAction('Delete')" type="danger" size="small" style="margin-left: 10px;">Delete Selected Tasks</el-button>
                        <el-button @click="multiSelectAction('Close')" :type="showingCompletedTasks ? 'success' : 'warning'" size="small" style="margin-left: 10px;">{{ showingCompletedTasks ? "Restore Selected Tasks" : "Close Selected Tasks" }}</el-button>
                    </div>

				</div>
			</section>
		</pagination>

		<el-table
			:row-key="setRowKeys"
            :key="_.size(tableData)"
			border
			v-loading="tableLoading"
			:data="tableData"
			style="width: 100%"
			:default-sort="{ prop: 'due', order: 'ascending' }"
			@selection-change="handleSelectionChange"
		>
			<el-table-column header-align="center" align="center" type="selection" width="55"></el-table-column>

			<el-table-column sortable prop="related_to" label="Related To">
				<template slot-scope="scope">
					<div v-if="_.has(scope, 'row.taskable.ref_id')">
						<a target="_blank" rel="noopener" :href="`/admin/applications/${scope.row.taskable.id}`">
							{{ scope.row.taskable_label }}
						</a>
					</div>
					<div v-else>
						<a target="_blank" rel="noopener" :href="`${_.get(scope.row, 'taskable.search_url', '')}`">
							{{ scope.row.taskable_label }}
						</a>
					</div>
				</template>
			</el-table-column>

			<el-table-column prop="application_stage" label="Current Stage"></el-table-column>

			<el-table-column sortable prop="task_name" label="Task"></el-table-column>

			<el-table-column sortable prop="broker.full_name" label="Assigned To">
				<template slot-scope="scope">
					<div v-html="getBrokerName(scope.row.broker)"></div>
				</template>
			</el-table-column>

			<el-table-column sortable prop="updated_at" label="Last Updated" width="200" :formatter="formatDate"></el-table-column>

			<el-table-column sortable prop="due" label="Due Date/Time" width="200">
				<template slot-scope="scope">
					<span :class="{ taskDue: isTaskDue(scope.row) }">{{ formatDueDate(scope.row) }}</span>
				</template>
			</el-table-column>

			<el-table-column width="200">
				<template slot-scope="scope">
					<el-dropdown class="w-100">
						<el-button style="color: green; width: 100%" size="small">
							Action
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="toggleTaskCompletion(scope.row)">
								<span>{{ scope.row.status_id == 1 ? "Complete" : "Restore" }} Task</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="openTaskModal(scope.row)">
								<span>Edit Task</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="deleteTask(scope.row)">
								<span>Delete Task</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>

		<pagination
			class="pagination-bottom"
			:total="tasks.total"
			:page.sync="tasks.current_page"
			:limit.sync="tasks.per_page"
			@pagination="getTasks(false)"
			@sizeChange="getTasks(true)"
			:separate-change="true"
			:page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
			:slotStacked="true"
			slotPosition="after"
		>
			<section class="w-100">
				<div class="w-100 d-flex justify-content-between">
					<el-button size="small" type="success" @click="openTaskModal()">Create Task</el-button>
					<el-button style="margin-left: 10px" size="small" type="primary" @click="getTasks(true)">Reload Tasks</el-button>
					<el-select v-model="filter" style="margin-left: 10px; width: 250px" size="small">
						<el-option v-for="item in options.filter" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<el-select
						v-if="showFilterByBroker"
						style="margin-left: 10px; width: 250px"
						size="small"
						v-model="filterBroker"
						clearable
						filterable
						placeholder="Filter by Broker"
                        :loading="_.isEmpty(brokerList)"
					>
						<el-option-group v-for="group in brokerList" :key="group.label" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-option-group>
					</el-select>
					<el-input clearable style="margin-left: 10px" size="small" v-model="search" placeholder="Search Tasks"></el-input>

                    <div v-if="_.size(multipleSelection) > 0 && _.get(brokerList, '0.options', false)" class="d-flex flex-row assign-user" style="margin-left: 10px;">
                        <el-select clearable filterable size="small" v-model="assignUserId" placeholder="Select Broker">
                            <el-option
                                v-for="broker in brokerList[0].options"
                                :key="broker.value"
                                :label="broker.label"
                                :value="broker.value">
                            </el-option>
                        </el-select>
                        <el-button @click="assignTasks" :disabled="!assignUserId" type="primary" size="small">Assign Tasks</el-button>
                    </div>

                    <div v-if="_.size(multipleSelection) > 0" class="d-flex flex-row" >
                        <el-button @click="multiSelectAction('Delete')" type="danger" size="small" style="margin-left: 10px;">Delete Selected Tasks</el-button>
                        <el-button @click="multiSelectAction('Close')" :type="showingCompletedTasks ? 'success' : 'warning'" size="small" style="margin-left: 10px;">{{ showingCompletedTasks ? "Restore Selected Tasks" : "Close Selected Tasks" }}</el-button>
                    </div>

				</div>
			</section>
		</pagination>

		<create-task-modal
			:token="token"
			:visible.sync="visible"
			:create.sync="create"
			:task="taskForm"
			:application-id="applicationId"
		></create-task-modal>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	import Pagination from "@shared/components/pagination"
	import CreateTaskModal from "@ambition/components/tasks/CreateTaskModal.vue"

	export default {
		name: "TasksTable",
		components: {
			Pagination,
			CreateTaskModal,
		},
		computed: {
			...mapGetters({
				user: "user/user",
				tasks: "tasks/getPaginatedTasks",
			}),
			tableData() {
				return _.get(this.tasks, "data", [])
			},
			showFilterByBroker() {
				return ["all-current-tasks", "all-completed-tasks"].includes(this.filter) ? true : false
			},
            showingCompletedTasks() {
                return ['all-completed-tasks', 'my-completed-tasks'].includes(this.filter) ? true : false
            }
		},
		props: {
			token: {
				required: true,
			},
			applicationId: {
				required: false,
			},
			brokerList: {
				required: false,
			},
			teamId: {
				required: false,
			},
            showAllTasks: {
                required: false,
                type: Boolean,
                default: false
            },
		},
		data() {
			return {
				headers: {
					headers: {
						Authorization: `Bearer ${this.token}`,
					},
				},
				options: {
					filter: [
						{
							label: "My Current Tasks",
							value: "my-current-tasks",
						},
						{
							label: "My Completed Tasks",
							value: "my-completed-tasks",
						},
                        {
							label: "My Overdue Tasks",
							value: "my-overdue-tasks",
						},
					],
				},
				multipleSelection: [],
                assignUserId: null,
				filterBroker: null,
				filter: "my-current-tasks",
				visible: false,
				create: true,
				tableLoading: true,
				search: "",
				searchTimeout: null,
				searchTimeoutWait: 1000,
				taskForm: {},
				taskFormRules: {},
			}
		},

		mounted() {
			// get tasks on mount
			this.getTasks(true)
			// if admin or manager give the ability to see all current and completed tasks
			if (Ambition.hasRoleOrPermission(["administrator", "manager"]) || this.showAllTasks) {
                this.filter = "all-current-tasks"
				this.options.filter = [
                    ...[
						{ label: "All Current Tasks", value: "all-current-tasks" },
						{ label: "All Completed Tasks", value: "all-completed-tasks" },
						{ label: "All Overdue Tasks", value: "all-overdue-tasks" },
					],
					...this.options.filter,
				]
			}
		},

		methods: {
            multiSelectAction(action) {

                let actionName = action
                if (action == "Close" && this.showingCompletedTasks) {
                    actionName = "Restore"
                }

                swal({
					title: "Are you sure?",
					type: "warning",
					text: `Are you sure you want to ${actionName} all selected tasks?`,
				}).then((res) => {
					if (res.value) {
						this.$store
                            .dispatch(`tasks/multi${action}Tasks`, {
                                action: actionName,
                                tasks: this.multipleSelection,
                                filter: this.filter,
                            })
                            .then((res) => {
                                this.tableLoading = false
                            })
                            .catch((err) => {
                                console.error(err)
                            })
                            .finally(() => {
                                this.multipleSelection = []
                            })
					}
				})
            },
            getBrokerName(broker) {
                if (broker) {
                    if (broker.deleted_at) {
                        return '<span style="color: red">' + broker.full_name + "</span>"
                    }
                    return broker.full_name
                }
                return ''
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			setRowKeys(row) {
				return row.id
			},
			formatDate(row, column, value, index) {
				if (value) return this.$moment.utc(value).tz(this.user.timezone).format("ddd DD/MM/YY LT")
				else return null
			},
			deleteTask(row) {
                let applicationId = row.taskable_type == 'App\\Models\\Tenant\\Application' ? row.taskable_id : false
                let data = {
                    applicationId: applicationId,
                    form: row
                }
				swal({
					title: "Are you sure?",
					type: "warning",
					text: "Are you sure you want to delete this task?",
				}).then((res) => {
					if (res.value) {
						this.$store.dispatch("tasks/deleteTask", data)
					}
				})
			},
			formatDueDate(row) {
				return this.$moment(row.due).format("ddd DD/MM/YY LT")
			},
			isTaskDue(row) {
				let now = this.$moment().tz(row.timezone).format("YYYY-MM-DD HH:mm:ss")
				let due = this.$moment(row.due_date + " " + row.time).format("YYYY-MM-DD HH:mm:ss")
				if (row.status_id == 2) return false
				return due < now
			},
			getTasks(resetPage) {
				this.tableLoading = true
				if (resetPage) this.tasks.current_page = 1
				let data = {
					brokerId: this.filterBroker,
					teamId: this.teamId,
					applicationId: this.applicationId,
					page: this.tasks.current_page,
					per_page: this.tasks.per_page,
					search: this.search,
					filter: this.filter,
					paginated: true
				}
				this.$store
					.dispatch("tasks/setTasks", data)
					.then((res) => {
						this.tableLoading = false
					})
					.catch((err) => {
						console.error(err)
					})
			},
            assignTasks() {
                let brokers = _.get(this.brokerList, '0.options', [])
                if (!_.isEmpty(brokers)) {
                    let selectedBroker = brokers.find(broker => broker.value == this.assignUserId)
                    swal({
                        title: "Assign Tasks?",
                        text: `You are about to assign ${_.size(this.multipleSelection)} tasks to ${selectedBroker.label}`,
                        type: "info",
                        showCancelButton: true,
                        cancelButtonText: "Cancel",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Assign Tasks",
                        confirmButtonColor: "#284da5",
                        reverseButtons: false,
                    }).then((actioned) => {
                        if (actioned.value) {
                            axios.post('/api/tasks/v2/assign-tasks', {
                                tasks: this.multipleSelection,
                                broker: this.assignUserId,
                            })
                            .then(res => {
                                this.assignUserId = null;
                                this.getTasks(true)
                            })
                            .catch(err => {
                                console.error(err);
                            })
                        }
                    })
                }
            },
			toggleTaskCompletion(row) {
				this.tableLoading = true
				this.$store
					.dispatch("tasks/toggleCompletion", row)
					.then((res) => {
						this.tableLoading = false
					})
					.catch((err) => {
						console.error(err)
					})
			},
			openTaskModal(row) {
				this.create = true
				this.taskForm = {}
				if (row) {
					this.create = false
					this.taskForm = Object.assign({}, row)
				}
				this.visible = true
				this.loading = false
			},
		},

		watch: {
			search: {
				handler() {
					if (this.searchTimeout) clearTimeout(this.searchTimeout)
					this.searchTimeout = setTimeout(() => {
						this.getTasks(true)
					}, this.searchTimeoutWait)
				},
			},
			filter: {
				handler(filter) {
					if (["my-current-tasks", "my-completed-tasks"].includes(filter)) {
						this.filterBroker = null
					}
					if (this.searchTimeout) clearTimeout(this.searchTimeout)
					this.searchTimeout = setTimeout(() => {
						this.getTasks(true)
					}, this.searchTimeoutWait)
				},
			},
			filterBroker: {
				handler() {
					if (this.searchTimeout) clearTimeout(this.searchTimeout)
					this.searchTimeout = setTimeout(() => {
						this.getTasks(true)
					}, this.searchTimeoutWait)
				},
			},
		},
	}
</script>

<style lang="scss" scoped>

    .assign-user {
        margin-left: 10px;

        .el-select {
            input {
                // border-color: #284da5 !important;
                border-top-right-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
                width: 200px;
            }
        }

        .el-button {
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
            margin-left: -1px;
            border-left: 0 !important;
        }
    }
	.section-table {
		background-color: #f0f3f5;
		border: 1px solid #c2cfd6;
		padding: 10px;

		.pagination-container {
			border: 1px solid #dcdfe6;
			border-radius: 5px;
			padding: 10px !important;

			&.pagination-top {
				margin-bottom: 10px !important;
			}

			&.pagination-bottom {
				margin-top: 10px !important;
				margin-bottom: 0 !important;
			}

			.el-pager {
				li {
					background-color: transparent;
					border: 1px solid #dcdfe6;
					font-weight: 400;

					&.active {
						background-color: #69c23a;
						border: none;
					}
				}
			}
		}

		.el-table {
			border: 1px solid #dcdfe6;
			border-radius: 5px;

			.el-table__expanded-cell {
				background: #ffffff;
				box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.7) inset;
			}

			.cell {
				word-break: break-word;

				.taskDue {
					color: red !important;
				}
			}

            .el-loading-mask {
                z-index: 1 !important;
            }
		}
	}
</style>
